import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import SignatureCanvas from 'react-signature-canvas';

const ComponentWrapper = styled.div`
    width: ${props => `${props.width}px`};
    height: 149px;
    display: flex;
    position: relative;
    
    /* default/gray/100 */
    background: #F4F7F9;
    /* default/gray/300 */
    border: 1px solid var(--gray-color-300);
    box-sizing: border-box;
`;

const ClearButton = styled.div`
    position: absolute;
    right: 0;
    align-self: center;
`;

function SignatureComponent({onSignatureBegin, onSignatureEnd, width = 593, setRef}) {
    const [signaturePad, setSignaturePad] = useState();

    useEffect(() => {
        if (setRef) setRef(signaturePad);
    }, [signaturePad]);

    return (
        <ComponentWrapper width={width}>

            <ClearButton width={width}>
                <IconButton
                    onClick={() => {
                        if (signaturePad) signaturePad.clear();
                    }}
                >
                    <Icon>cancel</Icon>
                </IconButton>
            </ClearButton>

            <SignatureCanvas
                ref={pad => setSignaturePad(pad)}
                onBegin={onSignatureBegin}
                onEnd={onSignatureEnd}
                style={{
                    width: '100%',
                    height: '100%'
                }}
                penColor="black"
                canvasProps={{width, height: 149, className: 'sigCanvas'}}
            />

        </ComponentWrapper>
    );
}

SignatureComponent.propTypes = {};
SignatureComponent.defaultProps = {};

export default SignatureComponent;
